// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/*= Z-INDEX GLOSSARY
/* [1]: Sketch Canvas
/* [11]: Sketch Blocker
/* [12]: Tile Bank Height Slider
/* [15]: Letter Tiles
/* [17]: Gradient Scrolling HotLinks
/* [18]: Canvas Element
/* [20]: Headers / Toolbars / Functional
/* [30]: Letter Tile Editing Screen
/* [100]: Black Background
/* [150]: Slide In Menu
*/

@font-face { font-family: 'Montserrat'; src: url('Montserrat-Regular.c2628153da0ff8d6.ttf') format('truetype'); }
@font-face { font-family: 'Montserrat'; font-weight: bold; src: url('Montserrat-Bold.99bbd17548239225.ttf') format('truetype'); }

html {
    font-size: 62.5%;
    font-family: "Arial", sans-serif;
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
}

body {
    font-family: "Arial", sans-serif;
    color: #4e5056;
    /* overflow: hidden; */
    margin: 0;
    padding: 0;
    background: #e1e6ec; /* Old browsers */ /* FF3.6+ */ /* Chrome,Safari4+ */ /* Chrome10+,Safari5.1+ */ /* Opera 11.10+ */ /* IE10+ */
    background: linear-gradient(to bottom, #e1e6ec 0%,#d9dee4 100%); /* W3C */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e1e6ec', endColorstr='#d9dee4',GradientType=0 ); /* IE6-9 */
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

body.ipadApp {
    top: 20px;
}

body.ipad { /* iPad fix for keyboard push up problems */
    background: #e1e6ec;
}

div.statusbar-bg {
    position: fixed;
    top: 0px;
    left: 0;
    width: 100%;
    height: 20px;
    background: #4c5878 url('header-bg.6c9c444d768c2ee1.png') repeat;
    z-index: 1000000;
    border-bottom: 1px solid #323232;
    box-shadow: inset 0px -1px 0px #5f6c8e;
}

div.statusbar-bg.fixfixed {
    position:absolute;
}

* {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
    -ms-touch-action: none;
}

input,select,textarea {
    -webkit-user-select: text;
}

/*= GLOBAL TEXT FORMATTING
=====================================*/


/* Style for Font Awesome Icons Before Text */
i.fa.beforetext {
    padding-right: 0.3em;
}

form {
    /*overflow: auto;*/
}

form .form_error {
    color: red;
    font-size: 12px;
    position: relative;
    top: -8px;
    left: 10px;
}

input[type="checkbox"],
input[type="radio"] {
    margin: 0 6px;
}

input[type="number"] {
    color: #707070;
    height:40px;
    width: 180px;
    padding: 8px;
    margin-top: 5px;
    margin-bottom: 10px;
    border: 1px solid #DDD;
    background: #ffffff;
    outline: 0;
    box-shadow: inset 1px 1px 2px rgba(238, 238, 238, 0.2);
    font-size: 17px;
    font-size: 1.7rem;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}


textarea {
    color: #000000;
    padding: 8px;
    margin-top: 5px;
    margin-bottom: 10px;
    border: 1px solid #DDD;
    background: #ffffff;
    outline: 0;
    box-shadow: inset 1px 1px 2px rgba(238, 238, 238, 0.2);
    font-size: 17px;
    /* font-size: 1.7rem; */
}

input[disabled],
select[disabled] {
    opacity: 0.5;
}

div[disabled] {
    opacity: 0.5;
}

.input_capitalize {
    text-transform: capitalize;
}

form select,
select,
.dropdown-default {
    -webkit-appearance: none;
    border: 1px solid #DDD;
    padding: 10px;
    font-size: 15px;
    border-radius: 3px;
    color: #707070;
    line-height: 1.1em;
    width: 180px;
    background: #fff url('dropdown-bg.240f55f4d67141c5.png') no-repeat center right;
    background-size: contain;
    margin: 5px 0;
}

.dropdown_fixed {
    line-height: 3.0em;
    padding: 0 5px;
    font-weight: bold;
}

a:link,
a:visited,
a.link {
    color: #F25D00;
    text-decoration: none;
    cursor: pointer;
}

a:hover
a.link:hover {
    color: #FF7E0D;
}

/* Used for Modal Form Submit Successes */
.successmsg {
    /*overflow:auto;*/
}

.successmsg img {
    margin-bottom: 20px;
}

#header-main {
    height: 100px;
    width: 100%;
}

#header-main.closed {
    /* IE 8 */
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    /* IE 5-7 */
    filter: alpha(opacity=0);
    /* Netscape */
    -moz-opacity: 0;
    /* Safari 1.x */
    -khtml-opacity: 0;
    /* Good browsers */
    opacity: 0;
    transform: translate3d(0,-50px,0);
}

.header-left {
    float: left;
    height: 100%;
}

.header-left div:first-child {
    border-left: none;
}

.header-right {
    float: right;
    height: 100%;
}

/*= NAVIGATION LINKS
============================================================*/



.header-left div[class^='nav-'] {
    text-transform: capitalize;
}

.header-left div[class^='nav-']:last-child {
    border-right: 1px solid #323232;
}

.header-left div[class^='nav-']:active {
    background-repeat: repeat-x;
    background-position: 0px 0px;
}

.header-left div[class^='nav-'].active {
    background-repeat: repeat-x;
    background-position: 0px 0px;
    background: rgba(0,0,0,0.15);
}

.header-right div[class^='nav-'] {
    float: left;
    border-left: 1px solid #323232;
    box-shadow: inset 1px 0 0px #5f6c8e;
}

.header-right div[class^='nav-']:active {
    background-repeat: repeat-x;
    background-position: 0px 0px;
}

.nav-.oneline {
    padding: 15px 19px;
    font-size: 1.3rem;
    font-family: 'Montserrat';
    letter-spacing: -0.03em;
}

.header-left div[class^='nav-'].oneline.active span {
    display: inline-block;
}

.header-left div[class^='nav-'].oneline i {
    margin-right: 10px;
}

@media (max-width: 925px) {
    .nav-.class.oneline span {
        display: none;
    }
    .header-left div[class^='nav-'].oneline i {
        margin-right: 0;
    }
    .header-left div[class^='nav-'].oneline.active i {
        margin-right: 10px;
    }
}

/*.header-left div[class^='nav-'].oneline span {
    display: none;
}*/

.nav-.twolines {
    padding: 7px 20px;
    position: relative;
}

.nav-.twolines.icon-left {
    padding: 7px 20px 7px 51px;
    position: relative;
}

.nav-.twolines.icon-left i.fa {
    font-size: 25px;
    position: absolute;
    top: 13px;
    left: 14px;
}

.nav-.twolines small {
    font-weight: normal;
}

.nav-.twolines span {
    line-height: 1.4em;
    text-transform: capitalize;
    font-size: 14px;
    font-size: 1.4rem;
}

.nav-.logo {
    padding: 14px;
}
.nav-.logo img {
    opacity: 0.5;
}

.nav-.menu {
    width: 50px;
    height: 50px;
    padding: 10px;
    font-size: 24px;
    text-align: center;
    line-height: 30px;
}

.nav-.loggout {
    width: 50px;
    height: 50px;
    padding: 10px;
}

.nav-.support {
    width: 50px;
    height: 50px;
    padding: 10px;
}

#titlebar {
    width: 100%;
    height: 63px;
    background: url('header-titlebar-bg.97fe2eb1709d3bfd.png') bottom;
    padding-top: 9px;
    font-family: Arial, sans-serif;
    font-size: 1.35rem;
    letter-spacing: 0.06em;
    font-weight: 400;
    color: #5b585f;
    text-align: center;
    z-index: 20;
    position:absolute;
    top: 50px;
    left: 0px;
    right: 0px;
    overflow: hidden;
    transition: all .2s ease-out;
    /* IE 8 */
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
    /* IE 5-7 */
    filter: alpha(opacity=100);
    /* Netscape */
    -moz-opacity: 1.0;
    /* Safari 1.x */
    -khtml-opacity: 1.0;
    /* Good browsers */
    opacity: 1.0;
    transform: translate3d(0,0,0);
}

#page-settings #titlebar {
    top: 0px;
}

#titlebar.short {
    height: 50px;
    padding: 0;
}

#titlebar.closed {
    /* IE 8 */
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    /* IE 5-7 */
    filter: alpha(opacity=0);
    /* Netscape */
    -moz-opacity: 0;
    /* Safari 1.x */
    -khtml-opacity: 0;
    /* Good browsers */
    opacity: 0;
    transform: translate3d(0,-85px,0);
}

.titlebar-left {
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
}

.titlebar-right {
    float: right;
}

.activitytool {
    display: inline-block;
}

div[class^='bbtools-'],
div[class^='fctools-'] {
    width: 80px;
    height: 35px;
    background-size: contain;
    float: left;
    margin: 5px 0;
    border-right: 1px solid #c9c9c9;
    cursor: pointer;
    /* IE 8 */
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=50)";
    /* IE 5-7 */
    filter: alpha(opacity=50);
    /* Netscape */
    -moz-opacity: 0.5;
    /* Safari 1.x */
    -khtml-opacity: 0.5;
    /* Good browsers */
    opacity: 0.5;
    text-align: left;
    padding-left: 20px;
}

div[class^='bbtools-']:not(.bbtools-penciloptions):active,
div[class^='bbtools-']:not(.bbtools-penciloptions).active {
    /* IE 8 */
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
    /* IE 5-7 */
    filter: alpha(opacity=100);
    /* Netscape */
    -moz-opacity: 1;
    /* Safari 1.x */
    -khtml-opacity: 1;
    /* Good browsers */
    opacity: 1;
}

.titlebar-right div[class^='bbtools-']:last-child {
    border-right: none;
}

.bbtools-lessonsettings,
.bbtools-tutorialvideos {
    font-size: 32px;
    font-size: 3.2rem;
}

.bbtools-text {
    font-size: 32px;
    font-size: 3.2rem;
}

.bbtools-text i {
    padding-left: 12px;
}

.bbtools-tiledrawer {
    background: url('bbtools-tiledrawer.4b8ae6188b46d89a.png') no-repeat center center;
}

.bbtools-pencil {
    background: url('bbtools-pencil.813a1a019ff93f2b.png') no-repeat center center;
    color: #000;
    font-size: 12px;
    font-size: 1.2rem;
}

.bbtools-eraser {
    background: url('bbtools-eraser.c9853b8faf3bb928.png') no-repeat center center;
}

.bbtools-undo {
    background: url('bbtools-undo.fa4c160d53e697d7.png') no-repeat center center;
}

.bbtools-shift {
    background: url('bbtools-shift.f691df7e92e450e3.png') no-repeat center center;
}

.bbtools-hide {
    background: url('bbtools-hide.9bb6a71bdf3b1779.png') no-repeat center center;
}

.bbtools-resize {
    background: url('bbtools-resize.621a73a0f338f229.png') no-repeat center center;
}

div[class^='fctools-'].fctools-syllabledivision {
    background: url('fctools-syllabledivision.3d38aa81344e7c09.png') no-repeat top center;
}

div[class^='fctools-'].fctools-syllabledivision.active {
    background-position: bottom center;
}

.bbtools-trash {
    background: url('bbtools-trash.983372852665e159.png') no-repeat center center;
}

div[class='bbtools-penciloptions'] {
    font-size: 30px;
    letter-spacing: 0.5em;
    width: auto;
    padding: 2px 10px 0 20px;
}

div.text-tool-draw {
    width:100%;
    height:100%;
}

div.text-tool-draw.pullout {
    padding-bottom: 30px;
}

div.text-tool-active {
    cursor: text;
}

div.text-box {
    background: rgba(255,255,255,.8);
    border-radius: 10px;
    padding: 12px 25px 12px 25px;
    z-index: 5;
    cursor: move;
}

div.text-box.ui-draggable-dragging {
    border: 1px dotted black;
}

div.text-box .close-text {
    position: absolute;
    top: 10px;
    right: 5px;
    height: 40px;
    font-size: 20px;
    opacity: .4;
    color: lightcoral;
    cursor: default;
}

div.text-box textarea {
    width: 100%;
    height: 100%;
    margin: 0;
    background: none;
    resize: none;
    -webkit-user-select: text;
    border: 1px rgba(0,0,0,.1) dotted;
    padding: 2px;
    font-size: 26px;
}

div.text-box .text-size-plus {
    font-size: 20px;
    position: absolute;
    top: 10px;
    left: -7px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    -webkit-user-select: none;
    cursor: default;
}

div.text-box .text-size-minus {
    font-size: 20px;
    position: absolute;
    bottom: 0px;
    left: -7px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    -webkit-user-select: none;
    cursor: default;
}

div.text-box.hidden {
    visibility: visible !important;
    background: transparent;
}

div.text-box.hidden .close-text, div.text-box.hidden .text-size-plus, div.text-box.hidden .text-size-minus, div.text-box.hidden .ui-resizable-handle {
    display: none !important;
}

div.text-box.hidden textarea {
    border: 1px solid transparent;
    visibility: visible;
}

span.text-width-span {
    margin:0;
    padding: 3px;
    display: table-cell;
}

.ui-selectable-helper {
    background: rgba(255,255,255,.8);
    border-radius: 10px;
}

.lessonbox_wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 50px;
    z-index: 151;
}

.fa.black {
    color: #000;
}

.fa.blue {
    color: #004aff;
}

.fa.red {
    color: #ab1f2c;
}

.fa.yellow {
    color: #ffe400;
}

.fa.green {
    color: #1eff00;
}

.fa.purple {
    color: #fc00ff;
}

.fa.orange {
    color: #ff8a00;
}

.fa.pink {
    color: #ff00ae;
}

#page-container {
    font-size: 15px;
    font-size: 1.5rem;
    height: 100%;
    width: auto;
    overflow:hidden;
    transition: all .25s ease-out;
}

div[id^='page-'] {
    transition: all .2s ease-out;
}

div[id^='page-'].ng-enter {
    transition: all .1s ease-out;
    -moz-opacity: 0;
    opacity: 0;
}

div[id^='page-'].ng-enter-active {
    -moz-opacity: 1;
    opacity: 1;
}

div[id^='page-'].ng-leave {
    -moz-opacity: 1;
    opacity: 1;
    transform: scale(1);
}

div[id^='page-'].ng-leave-active {
    -moz-opacity: 0;
    opacity: 0;
    transform: scale(0.99);
}

@media DISABLED {
    test {
        /* IE 8 */
        -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
        /* IE 5-7 */
        filter: alpha(opacity=0);
        /* Netscape */
        -moz-opacity: 0;
        /* Safari 1.x */
        -khtml-opacity: 0;
        /* Good browsers */
        opacity: 0;
    }

    #page-container.here {
        /* IE 8 */
        -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
        /* IE 5-7 */
        filter: alpha(opacity=100);
        /* Netscape */
        -moz-opacity: 1;
        /* Safari 1.x */
        -khtml-opacity: 1;
        /* Good browsers */
        opacity: 1;
    }
}


.clear {
    float: right;
    padding: 10px 20px;
    font-size: 15px;
}

.letter-tile {
    font-family: "Arial", sans-serif;
    font-size: 30px;
    font-size: 3.0rem;
    font-weight: bold;
    color: #fff;
    border-radius: 3px;
    border: 1px solid #CCC;
    display: inline-block;
    float: left;
    text-align: center;
    line-height: 1.8em;
    padding: 0 17px;
    min-width: 73px;
    cursor: pointer;
    background: #fff;
    margin: 3px 2px;
    z-index: 15;
    position:relative;
    box-shadow: 0px 1px #BBB;
    -ms-touch-action: none;
}

.letter-tile.capitalize {
    text-transform: capitalize;
}

.letter-tile-added {
    box-shadow: 0px 1px #BBB;
}

.letter-tile.ui-draggable-dragging {
    z-index: 999999;
}

.open-tile-drawer {
    float: right;
    padding: 10px 20px;
    font-size: 15px;
}

.page-header {
    width: 100%;
    overflow: auto;
}

.page-header h1 {
    display: block;
    float: left;
}

.page-header h3 {
    display: block;
    float: right;
    margin: 0.5em 0;
}

#modal-loggout {
    font-size: 14px;
    font-size: 1.4rem;
}

.base {
    display: -moz-inline-stack;
    display: inline-block;
    vertical-align: middle;
    *vertical-align: auto;
    zoom: 1;
    *display: inline;
    border-radius: 3px;
    cursor: pointer;
    border: 0;
    margin: 0 0.5em 0.5em 0;
    font-family: Arial;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    font-size: 0.8em;
    line-height: 1em;
    padding: 1em 2.5em;
    background: #FF8F2C;
    color: #FFF;
    outline: none;
    box-shadow: 0 1px 1px #646464;
    text-decoration: none;
    outline: none;
}


button.secondary {
    background: #eeeeee;
    color: #888888;
}

button.darkgray {
    background: #AAA;
    color: #FFF;
}

button.icon {
    display: inline-block;
    text-align: center;
    padding: 0.8em;
    box-shadow: none;
    border: 1px solid #D8D8D8;
    width: 70px;
}

button.icon i {
    font-size: 27px;
    font-size: 2.7rem;
    text-align: center;
    display: block;
    margin-bottom: 0.15em;
}

button.icon span {
    font-size: 1.0px;
    font-size: 1.0rem;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    text-align: center;
    display:block;
}

button.icon.highlight {
    border:1px solid #EDA465;
}

button[disabled] {
    opacity: 0.5;
}

a.button {
    display: -moz-inline-stack;
    display: inline-block;
    vertical-align: middle;
    *vertical-align: auto;
    zoom: 1;
    *display: inline;
    border-radius: 3px;
    cursor: pointer;
    border: 0;
    margin: 0 0.5em 0 0;
    font-family: inherit;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    font-size: 0.8em;
    line-height: 1em;
    padding: 1em 2.5em;
    background: #FF8F2C;
    color: white;
    outline: none;
    font-weight: bold;
    box-shadow: 0 1px 1px #646464;
}

a.button.secondary {
    background: #E9E9E9;
    color: #888888;
}

button:active,
a.button:active {
    box-shadow: inset 0px 1px 4px #4D4D4D;
    margin-top: 1px;
}

a.ngclicklink {
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
}

.supportVideoLink {
    color: #CACACA;
}

.black-bg,
.black-bg-modal {
    position: absolute;
    width: 100%;
    transition: opacity 0.2s; /* ease-out, top 0 0.2s, bottom 0 0.2s; /* Fade out over 0.2s, then translate away at 0.2s,  */
    background: #000;
    background: rgba(0,0,0,.8);
    /* IE 8 */
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    /* IE 5-7 */
    filter: alpha(opacity=0);
    /* Netscape */
    -moz-opacity: 0;
    /* Safari 1.x */
    -khtml-opacity: 0;
    /* Good browsers */
    opacity: 0;
    top: -9999px;
    bottom: 9999px;
    left: 0;
    z-index: 150;
}

.black-bg-modal.active {
    top: 0px;
    bottom: 0px;
    transition: opacity 0.2s; /* ease-out, top 0, bottom 0; /* Translate into place over 0.2s, fade in at 0.2s */
    /* IE 8 */
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
    /* IE 5-7 */
    filter: alpha(opacity=100);
    /* Netscape */
    -moz-opacity: 1.0;
    /* Safari 1.x */
    -khtml-opacity: 1.0;
    /* Good browsers */
    opacity: 1.0;
}

.black-bg.active {
    top: 50px;
    bottom: 0px;
    transition: opacity 0.2s ease-out, top 0, bottom 0; /* Translate into place over 0.2s, fade in at 0.2s */
    /* IE 8 */
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
    /* IE 5-7 */
    filter: alpha(opacity=100);
    /* Netscape */
    -moz-opacity: 1.0;
    /* Safari 1.x */
    -khtml-opacity: 1.0;
    /* Good browsers */
    opacity: 1.0;
}

.black-bg.active.full {
    top: 0px;
}

.slidemenu {
    padding-bottom: 100px;
}

.slidemenu.menuright {
    z-index: 151;
    position: absolute;
    right: 0;
    top: 51px;
    bottom: 0px;
    width: 200px;
    background: #e6e6e6;
    box-shadow: inset 2px 0px 5px #A0A0A0;
    transition: all .2s ease-out;
    transform: translate3d(200px,0,0);
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}

.slidemenu.menuright.active {
    transform: translate3d(0,0,0);
}

.slidemenu.menuleft {
    z-index: 151;
    position: absolute;
    left: 0;
    top: 51px;
    bottom: 0px;
    width: 300px;
    background: #e6e6e6;
    box-shadow: inset 2px 0px 5px #A0A0A0;
    transition: all .2s ease-out;
    transform: translate3d(-300px,0,0);
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}

.slidemenu.menuleft.active {
    transform: translate3d(0,0,0);
}

.slidemenu ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.slidemenu ul li {
    font-size: 16px;
    font-size: 1.6rem;
    font-family: 'Arial';
    font-weight: bold;
    padding: 16px;
    border-bottom: 1px solid #cacaca;
}

.slidemenu ul li.disabled {
    opacity: .5;
}

.slidemenu ul li:hover {
    background: #CDCDCD;
    cursor: pointer;
}

.slidemenu ul li:active {
    background: #CDCDCD;
    cursor: pointer;
}

.slidemenu.menuleft ul li {
    font-size: 13px;
    font-size: 1.3rem;
    font-weight: normal;
    padding: 15px;
}

.scroll-fix-wrapper {
    overflow: auto;
    -webkit-transform: translateZ(0);
    height: 100%;
}

.scrollable {
    -webkit-overflow-scrolling: touch;
}

/*= ALERT BOXES
============================================================*/

.alert-box {
    color:#555;
    border-radius:6px;
    font-family:Arial,sans-serif;
    font-size: 12px;
    font-size: 1.2rem;
    padding: 10px 20px;
    line-height: 1.4em;
    margin:0 0 20px;
}

.alert-box span {
    font-weight:bold;
    text-transform:uppercase;
}

.error {
    background:#ffecec;
    border:1px solid #f5aca6;
}
.success {
    background:#e9ffd9;
    border:1px solid #a6ca8a;
}
.warning {
    background:#fff8c4;
    border:1px solid #f2c779;
}
.notice {
    background:#e3f7fc;
    border:1px solid #8ed9f6;
}

/*= LAYOUT FRAMES
=================================================*/

.paperbox {
    border-radius: 3px;
    border: 1px solid #DDD;
    box-shadow: 0px 1px 1px #AAA;
    background: rgba(248, 248, 248, 1);
}

.paperbox.new {
    background: rgba(250, 250, 250, 0.5);
    padding: 15px;
    box-shadow: none;
    border: 1.5px dashed #BBB;
    cursor: pointer;
}

.paperbox.new :active {
    background: rgba(250, 250, 250, 1);
}

.paperbox.warning {
    background: rgba(250, 250, 207, 0.5);
    padding: 15px;
    box-shadow: none;
    border: 1.5px dashed #DBD37A;
    cursor: pointer;
}

.paperbox.inverse {
    box-shadow: inset 0px 1px 1px #AAA;
    border: 1px solid #D2D2D2;
}

.paperbox .closebutton {
    float: right;
    font-size: 20px;
    font-size: 2.0rem;
    cursor: pointer;
}

.paperbox .title {
    font-size: 13px;
    font-size: 1.3rem;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    font-weight: bold;
    padding-bottom: 0.8em;
    display: block;
    border-bottom: 1px solid #CCC;
    margin-bottom: 15px;
}

.paperbox .title .title_action {
    text-transform: none;
    letter-spacing: 0;
    float: right;
    font-size: 14px;
    font-weight: normal;
}

.inputblock {
    display: inline-block;
    margin-right: 20px;
    margin-bottom: 15px;
}

/*= AUDIO PLAY BUTTON
=================================================*/

button.audio-button,
.audio-button {
    display: inline-block;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    line-height: 50px;
    padding: 0;
    text-align: center;
    font-size: 20px;
    text-indent: 4px;
}

.audio-button {
    margin-right: 15px;
}

/*= MODAL STYLES
=================================================*/

.modal {
    position: fixed;
    z-index: 151;
    width: 400px;
    margin-left: -200px;
    left: 50%;
    top: -2000px;
    border-radius: 5px;
    font-family: inherit;
    background: white;
    color: #444444;
    font-size: 16px;
    font-size: 1.6rem;
    line-height: 1.5em;
    transform: translateZ(0);
    transition: all 0.4s;
    -moz-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));
    filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));
}

.modal.video {
    width: 690px;
    margin-left: -345px;
}

.modal.modal_tour {
    width: 600px;
    margin-left: -300px;
}

.modal.active {
    top: 18%;
    transform: translate3d(0,0,0);
}

.modal header {
    background: #eeeeee;
    padding: 1em;
    border-radius: 5px 5px 0 0;
    overflow: auto;
    padding: 1em;
}

.modal header h3 {
     float: left;
     line-height: 1em;
     margin: 0;
     font-weight: normal;
}

.modal header a.modal-cancel-link {
    float: right;
    text-decoration: none;
    font-size: 1.25em;
    line-height: 0.8em;
    font-weight: normal;
    color: rgba(0, 0, 0, 0.5);
    opacity: 0.25;
    position: relative;
    margin-bottom: -0.8em;
}

.modal header a.modal-cancel-link:hover {
    opacity: 1;
}

.modal .modal-spinner {
    padding: 30px 0;
    text-align: center;
}

.modal .modal-body {
    padding: 1.5em;
    overflow: auto;
}

.modal .modal-body.restrict-height {
    max-height: 420px;
}

.modal .modal-body.no-padding {
    padding: 0;
}

.modal .modal-body p {
    margin-top: 0;
    padding-top: 0;
    margin-bottom: 30px;
}

.modal_tour_carousel {
    min-height: 460px;
    margin: 0;
    padding: 0;
}

.modal-body .modal_tour_carousel p {
    padding: 10px 20px;
    margin: 0;
}

.fa.bigsign {
    font-size: 180px;
    font-size: 18.0rem;
    opacity: 0.5;
}

.fa.mediumsign {
    font-size: 100px;
    font-size: 10.0rem;
    opacity: 0.5;
    margin-bottom: 15px;
}

.modal form label {
    display: inline-block;
    margin-bottom: 10px;
    color: #5E5E5E;
    width: 100%;
}

.modal form label.half-width {
    width: 49%;
}

.modal form label.half-width input {
    width: 90%;
}

.modal form input[type="text"],
.modal form input[type="number"],
.modal form input[type="email"],
.modal form textarea {
    color: #555;
    width: 100%;
    padding: 0px 8px;
    margin-top: 2px;
    margin-bottom: 10px;
    border: 1px solid #DDD;
    background: #FBFBFB;
    outline: 0;
    box-shadow: inset 1px 1px 2px rgba(238, 238, 238, 0.2);
}

.modal form select {
    -webkit-appearance: none;
    border: 1px solid #DDD;
    padding: 10px;
    font-size: 15px;
    border-radius: 3px;
    color: #707070;
    line-height: 1.2em;
    width: 180px;
    background: #fff url('dropdown-bg.240f55f4d67141c5.png') no-repeat center right;
    background-size: contain;
    margin: 5px 0;
    width: 100%;
}

.modal form textarea {
    height: 200px;
    padding: 10px;
}

.modal ul.menu-list {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.modal ul.menu-list li {
    cursor: pointer;
    margin: 0;
    padding: 20px;
    border-bottom: 1px solid #CCC;
}

.modal ul.menu-list li:hover {
    background: #f8f8f8;
}

.modal .footer {
    margin-top: 8px;
    text-align: center;
}

/*= ANIMATING LOADER STYLES
=================================================*/

.spinner {
  margin: 0 auto;
  width: 50px;
  text-align: center;
}

.page-loader {
    height: 100%;
    width: auto;
    overflow: hidden;
}

.spinner > div {
  width: 10px;
  height: 10px;
  background-color: #9CA3B4;
  border-radius: 100%;
  display: inline-block;
  animation: bouncedelay 1.4s infinite ease-in-out;
  /* Prevent first frame from flickering when animation starts */
  animation-fill-mode: both;
}

.page-loader .spinner {
    position: absolute;
    top: 40%;
    width: 100%;
}

.page-loader .spinner.page-error {
    top: 35%;
}

.page-loader .spinner.page-error > i {
    font-size: 80px;
    font-size: 8.0rem;
}

.page-loader .page-loader-quotes {
    position: absolute;
    text-align: center;
    top: 45%;
    width: 100%;
    margin-top: 20px;
    font-size: 1.8rem;
    line-height: 1.5em;
}

.page-loader .spinner > div {
    width: 20px;
    height: 20px;
}

.spinner .bounce1 {
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  animation-delay: -0.16s;
}

@keyframes bouncedelay {
  0%, 80%, 100% {
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  } 40% {
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
}

/*= Activity Tool Styles
=================================================*/

.red-circle {
    width: 8px;
    height: 8px;
    background: #ff5a5a;
    border-radius: 50px;
    position: absolute;
    right: 4px;
    top: 4px;
}

.disable-activity {
    cursor: not-allowed !important;
    color: lightgrey !important;
}

#sketch-blocker {
    position: absolute;
    top: 0px;
    z-index: 11;
    width: 100%;
    height: 100%;
    display: none;
    -ms-touch-action: none;
}

.hide-arrow{
    display: none;
}

#pulloutscreen {
    z-index: 18;
    width: 96%;
    height: 2000px;
    position: absolute;
    top: -1868px;
    left: 50%;
    margin-left: -48%;
    background: #fff;
    /*border: 1px solid #c7ca81;*/
    box-shadow: 0px 2px 5px rgba(0,0,0,0.132);
    background: rgb(255,255,255,0.22); /* Old browsers */ /* FF3.6+ */ /* Chrome,Safari4+ */ /* Chrome10+,Safari5.1+ */ /* Opera 11.10+ */ /* IE10+ */
    background: linear-gradient(to bottom, rgba(255,255,255,0.22) 0%,rgba(255,252,246,0.22) 100%); /* W3C */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#fffcf6',GradientType=0 ); /* IE6-9 */
    transition: all .18s ease-out;
    transform: translate3d(0,0,0);
}

#pulloutscreen-sketch {
    height: 2000px;
    width: 100%;
}

#pulloutscreen-handle {
    width: 100%;
    height: 30px;
    position: absolute;
    bottom: -3px;
    background: url('transparencyhandle.9ac4d0ebf7efb16a.png') no-repeat center bottom;
}

.no_content_container{
    padding: 50px 200px 0 200px;
    height: 100%;
    font-size: 2.5rem;
    font-weight: bold;
    text-align: center;
}
.videowrapper_no_content{
    width: 400px;
    height: 225px;
    position: relative;
    right: 0;
    left: 0;
    margin: auto;
    margin-bottom: 20px;
}

.add_content_btn{
    width: 170px;
    margin-top: 30px !important;
    font-size: small;
    padding-right: 0;
    padding-left: 0;
}

.no_content_message{
    font-size: 20px;
}

.workbook_arrow{
     cursor: pointer;
     font-size: larger !important;
     margin-left: 10px;
     margin-right: 10px;
 }

.header_cover {
    height: 50px;
    z-index: 21;
    width: 100%;
    background-color: gray;
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    -moz-opacity: 0.4;;
    -khtml-opacity: 0.4;;
    opacity: 0.4;
}

.word-bar {
  width: 15%;
  background-color: #F8F8F8;
}

.word {
  padding: 20px;
  border-bottom: 2px #ccc solid;
}

.word span {
  font-size: larger;
}

.workbook-edit-name {
  font-size: x-large;
  width: 50%;
  color: #888;
  margin-left: 20px;
  margin-top: 15px;
}

app-header-element {
  z-index: 100;
}


/* .flashcard {
  font-family: "Arial", sans-serif;
  font-size: 120px !important;
  line-height: 15vw;
  font-weight: bold;
  display: inline-block;
  width: auto !important;
  height: 433px !important;
  text-align: center;
  padding-top: 3%;
  flex-shrink: 3;
  border-radius: 8px ;
  box-shadow: 0 4px 16px 0 rgba(33, 8, 84, 0.08) ;
  background-color: #ffffff;
  color: #210854 ;
} */

.tiles {
  height: 20vh;
  line-height: 6rem;
  padding-right: 15px;
  padding-left: 15px;
}

.bumping-tile {
  border: 2px black solid;
  height: 100px;
  width: 100px;
  position: absolute;
  text-align: center;
}


/* header styling */
.sidenav {
    width: 20vh;
    height: 100vw;
    position: fixed;
    background-color: black;
    z-index: 100;
    float: left;
  }
`, "",{"version":3,"sources":["webpack://./src/assets/css/main.css"],"names":[],"mappings":";AACA;;;;;;;;;;;CAWC;;AAED,aAAa,yBAAyB,EAAE,sEAA2D,EAAE;AACrG,aAAa,yBAAyB,EAAE,iBAAiB,EAAE,mEAAwD,EAAE;;AAErH;IACI,gBAAgB;IAChB,gCAAgC;IAChC,YAAY;IACZ,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,mBAAmB,EAAE,iBAAiB,EAC2B,WAAW,EACmC,oBAAoB,EAChE,yBAAyB,EAC9B,iBAAiB,EAChB,UAAU;IACzE,+DAA+D,EAAE,QAAQ;IACzE,mHAAmH,EAAE,UAAU;IAC/H,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA,YAAY,2CAA2C;IACnD,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gEAAsD;IACtD,gBAAgB;IAChB,gCAAgC;IAChC,sCAAsC;AAC1C;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IAGI,sBAAsB;IACtB,mCAAmC;IACnC,2BAA2B;IAC3B,yBAAyB;IAIzB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;sCACsC;;;AAGtC,6CAA6C;AAC7C;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IAEV,sDAAsD;IACtD,eAAe;IACf,iBAAiB;AACrB;AACA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;;AAGA;IACI,cAAc;IACd,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IAEV,sDAAsD;IACtD,eAAe;IACf,uBAAuB;AAC3B;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;;IAGI,wBAAwB;IACxB,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,+EAAqE;IACrE,wBAAwB;IACxB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;;;IAGI,cAAc;IACd,qBAAqB;IACrB,eAAe;AACnB;;AAEA;;IAEI,cAAc;AAClB;;AAEA,yCAAyC;AACzC;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,SAAS;IACT,gEAAgE;IAChE,WAAW;IACX,wBAAwB;IACxB,aAAa;IACb,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IAKV,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;6DAC6D;;;;AAI7D;IACI,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,8BAA8B;IAC9B,mCAAmC;AACvC;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA;;EAEE;;AAEF;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iEAAuD;IACvD,gBAAgB;IAChB,8BAA8B;IAC9B,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,SAAS;IACT,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,4BAA4B;IAC5B,SAAS;IACT,kEAAkE;IAClE,WAAW;IACX,0BAA0B;IAC1B,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IAKZ,6BAA6B;AACjC;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,SAAS;IACT,gEAAgE;IAChE,WAAW;IACX,wBAAwB;IACxB,aAAa;IACb,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IAKV,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,WAAW;IACX,aAAa;IACb,+BAA+B;IAC/B,eAAe;IACf,SAAS;IACT,iEAAiE;IACjE,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,SAAS;IACT,kEAAkE;IAClE,WAAW;IACX,0BAA0B;IAC1B,aAAa;IACb,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kFAAwE;AAC5E;;AAEA;IACI,8EAAoE;IACpE,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,8EAAoE;AACxE;;AAEA;IACI,4EAAkE;AACtE;;AAEA;IACI,6EAAmE;AACvE;;AAEA;IACI,4EAAkE;AACtE;;AAEA;IACI,8EAAoE;AACxE;;AAEA;IACI,qFAA2E;AAC/E;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,6EAAmE;AACvE;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,4BAA4B;IAC5B,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,iCAAiC;IACjC,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,QAAQ;IACR,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,UAAU;AACd;;AAEA;IACI,eAAe;IACf,UAAU;AACd;;AAEA;IACI,eAAe;IACf,UAAU;IAKV,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,UAAU;IAKV,sBAAsB;AAC1B;;AAEA;IACI;QACI,SAAS;QACT,gEAAgE;QAChE,WAAW;QACX,wBAAwB;QACxB,aAAa;QACb,eAAe;QACf,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,SAAS;QACT,kEAAkE;QAClE,WAAW;QACX,0BAA0B;QAC1B,aAAa;QACb,eAAe;QACf,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,UAAU;IACd;AACJ;;;AAGA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;IACrB,sBAAsB;KACtB,oBAAqB;IACrB,OAAO;KACP,eAAgB;IAKhB,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,6BAA6B;IAC7B,qBAAqB;IACrB,aAAa;AACjB;;;AAGA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;IACrB,sBAAsB;KACtB,oBAAqB;IACrB,OAAO;KACP,eAAgB;IAKhB,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,mBAAmB;IACnB,oBAAoB;IACpB,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,wBAAwB,EAAE,8FAA8F;IACxH,gBAAgB;IAChB,0BAA0B;IAC1B,SAAS;IACT,gEAAgE;IAChE,WAAW;IACX,wBAAwB;IACxB,aAAa;IACb,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,cAAc;IACd,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,QAAQ;IACR,WAAW;IACX,wBAAwB,EAAE,kFAAkF;IAC5G,SAAS;IACT,kEAAkE;IAClE,WAAW;IACX,0BAA0B;IAC1B,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,kDAAkD,EAAE,oDAAoD;IACxG,SAAS;IACT,kEAAkE;IAClE,WAAW;IACX,0BAA0B;IAC1B,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,qCAAqC;IACrC,4BAA4B;IAK5B,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IAKI,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,qCAAqC;IACrC,4BAA4B;IAK5B,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IAKI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;6DAC6D;;AAE7D;IACI,UAAU;IACV,iBAAiB;IACjB,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;kDACkD;;AAElD;IACI,kBAAkB;IAClB,sBAAsB;IACtB,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;IACd,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;kDACkD;;AAElD;;IAEI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;kDACkD;;AAElD;IACI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,SAAS;IACT,YAAY;IAKZ,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAKlB,wBAAwB;IACxB,oBAAoB;IAEpB,sDAAsD;IACtD,iDAAiD;AACrD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,QAAQ;IAKR,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,YAAY;IAKZ,0BAA0B;IAC1B,cAAc;IACd,YAAY;AAChB;;AAEA;KACK,WAAW;KACX,gBAAgB;KAChB,SAAS;KACT,mBAAmB;AACxB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;;;;IAII,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IAEV,sDAAsD;AAC1D;;AAEA;IACI,wBAAwB;IACxB,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,+EAAqE;IACrE,wBAAwB;IACxB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,SAAS;IACT,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;kDACkD;;AAElD;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EAErB,gDAAgD;EAChD,8DAA8D;EAE9D,yBAAyB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;EAEE,uBAAuB;AACzB;;AAEA;EAEE,uBAAuB;AACzB;;AAOA;EACE;IACE,qBAAqB;IACrB,6BAA6B;EAC/B,EAAE;IACA,qBAAqB;IACrB,6BAA6B;EAC/B;AACF;;AAEA;kDACkD;;AAElD;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAG7B,yCAAyC;IACzC,iCAAiC,EAAE,iBAAiB,EAC2C,WAAW,EACmC,oBAAoB,EAChE,yBAAyB,EAC9B,iBAAiB,EAChB,UAAU;IACvG,6FAA6F,EAAE,QAAQ;IACvG,mHAAmH,EAAE,UAAU;IAC/H,6BAA6B;IAK7B,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kFAAwE;AAC5E;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;KACK,eAAe;KACf,4BAA4B;KAC5B,iBAAiB;KACjB,kBAAkB;CACtB;;AAED;IACI,YAAY;IACZ,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;;AAGA;;;;;;;;;;;;;;;GAeG;;AAEH;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;;AAGA,mBAAmB;AACnB;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb","sourcesContent":["\n/*= Z-INDEX GLOSSARY\n/* [1]: Sketch Canvas\n/* [11]: Sketch Blocker\n/* [12]: Tile Bank Height Slider\n/* [15]: Letter Tiles\n/* [17]: Gradient Scrolling HotLinks\n/* [18]: Canvas Element\n/* [20]: Headers / Toolbars / Functional\n/* [30]: Letter Tile Editing Screen\n/* [100]: Black Background\n/* [150]: Slide In Menu\n*/\n\n@font-face { font-family: 'Montserrat'; src: url('fonts/Montserrat-Regular.ttf') format('truetype'); }\n@font-face { font-family: 'Montserrat'; font-weight: bold; src: url('fonts/Montserrat-Bold.ttf') format('truetype'); }\n\nhtml {\n    font-size: 62.5%;\n    font-family: \"Arial\", sans-serif;\n    height: 100%;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n}\n\nbody {\n    font-family: \"Arial\", sans-serif;\n    color: #4e5056;\n    /* overflow: hidden; */\n    margin: 0;\n    padding: 0;\n    background: #e1e6ec; /* Old browsers */\n    background: -moz-linear-gradient(top, #e1e6ec 0%, #d9dee4 100%); /* FF3.6+ */\n    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#e1e6ec), color-stop(100%,#d9dee4)); /* Chrome,Safari4+ */\n    background: -webkit-linear-gradient(top, #e1e6ec 0%,#d9dee4 100%); /* Chrome10+,Safari5.1+ */\n    background: -o-linear-gradient(top, #e1e6ec 0%,#d9dee4 100%); /* Opera 11.10+ */\n    background: -ms-linear-gradient(top, #e1e6ec 0%,#d9dee4 100%); /* IE10+ */\n    background: linear-gradient(to bottom, #e1e6ec 0%,#d9dee4 100%); /* W3C */\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e1e6ec', endColorstr='#d9dee4',GradientType=0 ); /* IE6-9 */\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n\nbody.ipadApp {\n    top: 20px;\n}\n\nbody.ipad { /* iPad fix for keyboard push up problems */\n    background: #e1e6ec;\n}\n\ndiv.statusbar-bg {\n    position: fixed;\n    top: 0px;\n    left: 0;\n    width: 100%;\n    height: 20px;\n    background: #4c5878 url('../img/header-bg.png') repeat;\n    z-index: 1000000;\n    border-bottom: 1px solid #323232;\n    box-shadow: inset 0px -1px 0px #5f6c8e;\n}\n\ndiv.statusbar-bg.fixfixed {\n    position:absolute;\n}\n\n* {\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    -webkit-font-smoothing: antialiased;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -ms-touch-action: none;\n}\n\ninput,select,textarea {\n    -webkit-user-select: text;\n}\n\n/*= GLOBAL TEXT FORMATTING\n=====================================*/\n\n\n/* Style for Font Awesome Icons Before Text */\ni.fa.beforetext {\n    padding-right: 0.3em;\n}\n\nform {\n    /*overflow: auto;*/\n}\n\nform .form_error {\n    color: red;\n    font-size: 12px;\n    position: relative;\n    top: -8px;\n    left: 10px;\n}\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n    margin: 0 6px;\n}\n\ninput[type=\"number\"] {\n    color: #707070;\n    height:40px;\n    width: 180px;\n    padding: 8px;\n    margin-top: 5px;\n    margin-bottom: 10px;\n    border: 1px solid #DDD;\n    background: #ffffff;\n    outline: 0;\n    -webkit-box-shadow: inset 1px 1px 2px rgba(238, 238, 238, 0.2);\n    box-shadow: inset 1px 1px 2px rgba(238, 238, 238, 0.2);\n    font-size: 17px;\n    font-size: 1.7rem;\n}\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n\ntextarea {\n    color: #000000;\n    padding: 8px;\n    margin-top: 5px;\n    margin-bottom: 10px;\n    border: 1px solid #DDD;\n    background: #ffffff;\n    outline: 0;\n    -webkit-box-shadow: inset 1px 1px 2px rgba(238, 238, 238, 0.2);\n    box-shadow: inset 1px 1px 2px rgba(238, 238, 238, 0.2);\n    font-size: 17px;\n    /* font-size: 1.7rem; */\n}\n\ninput[disabled],\nselect[disabled] {\n    opacity: 0.5;\n}\n\ndiv[disabled] {\n    opacity: 0.5;\n}\n\n.input_capitalize {\n    text-transform: capitalize;\n}\n\nform select,\nselect,\n.dropdown-default {\n    -webkit-appearance: none;\n    border: 1px solid #DDD;\n    padding: 10px;\n    font-size: 15px;\n    border-radius: 3px;\n    color: #707070;\n    line-height: 1.1em;\n    width: 180px;\n    background: #fff url('../img/dropdown-bg.png') no-repeat center right;\n    background-size: contain;\n    margin: 5px 0;\n}\n\n.dropdown_fixed {\n    line-height: 3.0em;\n    padding: 0 5px;\n    font-weight: bold;\n}\n\na:link,\na:visited,\na.link {\n    color: #F25D00;\n    text-decoration: none;\n    cursor: pointer;\n}\n\na:hover\na.link:hover {\n    color: #FF7E0D;\n}\n\n/* Used for Modal Form Submit Successes */\n.successmsg {\n    /*overflow:auto;*/\n}\n\n.successmsg img {\n    margin-bottom: 20px;\n}\n\n#header-main {\n    height: 100px;\n    width: 100%;\n}\n\n#header-main.closed {\n    /* IE 8 */\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    /* IE 5-7 */\n    filter: alpha(opacity=0);\n    /* Netscape */\n    -moz-opacity: 0;\n    /* Safari 1.x */\n    -khtml-opacity: 0;\n    /* Good browsers */\n    opacity: 0;\n    -webkit-transform: translate3d(0,-50px,0);\n    -moz-transform: translate3d(0,-50px,0);\n    -ms-transform: translate3d(0,-50px,0);\n    -o-transform: translate3d(0,-50px,0);\n    transform: translate3d(0,-50px,0);\n}\n\n.header-left {\n    float: left;\n    height: 100%;\n}\n\n.header-left div:first-child {\n    border-left: none;\n}\n\n.header-right {\n    float: right;\n    height: 100%;\n}\n\n/*= NAVIGATION LINKS\n============================================================*/\n\n\n\n.header-left div[class^='nav-'] {\n    text-transform: capitalize;\n}\n\n.header-left div[class^='nav-']:last-child {\n    border-right: 1px solid #323232;\n}\n\n.header-left div[class^='nav-']:active {\n    background-repeat: repeat-x;\n    background-position: 0px 0px;\n}\n\n.header-left div[class^='nav-'].active {\n    background-repeat: repeat-x;\n    background-position: 0px 0px;\n    background: rgba(0,0,0,0.15);\n}\n\n.header-right div[class^='nav-'] {\n    float: left;\n    border-left: 1px solid #323232;\n    box-shadow: inset 1px 0 0px #5f6c8e;\n}\n\n.header-right div[class^='nav-']:active {\n    background-repeat: repeat-x;\n    background-position: 0px 0px;\n}\n\n.nav-.oneline {\n    padding: 15px 19px;\n    font-size: 1.3rem;\n    font-family: 'Montserrat';\n    letter-spacing: -0.03em;\n}\n\n.header-left div[class^='nav-'].oneline.active span {\n    display: inline-block;\n}\n\n.header-left div[class^='nav-'].oneline i {\n    margin-right: 10px;\n}\n\n@media (max-width: 925px) {\n    .nav-.class.oneline span {\n        display: none;\n    }\n    .header-left div[class^='nav-'].oneline i {\n        margin-right: 0;\n    }\n    .header-left div[class^='nav-'].oneline.active i {\n        margin-right: 10px;\n    }\n}\n\n/*.header-left div[class^='nav-'].oneline span {\n    display: none;\n}*/\n\n.nav-.twolines {\n    padding: 7px 20px;\n    position: relative;\n}\n\n.nav-.twolines.icon-left {\n    padding: 7px 20px 7px 51px;\n    position: relative;\n}\n\n.nav-.twolines.icon-left i.fa {\n    font-size: 25px;\n    position: absolute;\n    top: 13px;\n    left: 14px;\n}\n\n.nav-.twolines small {\n    font-weight: normal;\n}\n\n.nav-.twolines span {\n    line-height: 1.4em;\n    text-transform: capitalize;\n    font-size: 14px;\n    font-size: 1.4rem;\n}\n\n.nav-.logo {\n    padding: 14px;\n}\n.nav-.logo img {\n    opacity: 0.5;\n}\n\n.nav-.menu {\n    width: 50px;\n    height: 50px;\n    padding: 10px;\n    font-size: 24px;\n    text-align: center;\n    line-height: 30px;\n}\n\n.nav-.loggout {\n    width: 50px;\n    height: 50px;\n    padding: 10px;\n}\n\n.nav-.support {\n    width: 50px;\n    height: 50px;\n    padding: 10px;\n}\n\n#titlebar {\n    width: 100%;\n    height: 63px;\n    background: url('../img/header-titlebar-bg.png') bottom;\n    padding-top: 9px;\n    font-family: Arial, sans-serif;\n    font-size: 1.35rem;\n    letter-spacing: 0.06em;\n    font-weight: 400;\n    color: #5b585f;\n    text-align: center;\n    z-index: 20;\n    position:absolute;\n    top: 50px;\n    left: 0px;\n    right: 0px;\n    overflow: hidden;\n    transition: all .2s ease-out;\n    /* IE 8 */\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n    /* IE 5-7 */\n    filter: alpha(opacity=100);\n    /* Netscape */\n    -moz-opacity: 1.0;\n    /* Safari 1.x */\n    -khtml-opacity: 1.0;\n    /* Good browsers */\n    opacity: 1.0;\n    -webkit-transform: translate3d(0,0,0);\n    -moz-transform: translate3d(0,0,0);\n    -ms-transform: translate3d(0,0,0);\n    -o-transform: translate3d(0,0,0);\n    transform: translate3d(0,0,0);\n}\n\n#page-settings #titlebar {\n    top: 0px;\n}\n\n#titlebar.short {\n    height: 50px;\n    padding: 0;\n}\n\n#titlebar.closed {\n    /* IE 8 */\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    /* IE 5-7 */\n    filter: alpha(opacity=0);\n    /* Netscape */\n    -moz-opacity: 0;\n    /* Safari 1.x */\n    -khtml-opacity: 0;\n    /* Good browsers */\n    opacity: 0;\n    -webkit-transform: translate3d(0,-85px,0);\n    -moz-transform: translate3d(0,-85px,0);\n    -ms-transform: translate3d(0,-85px,0);\n    -o-transform: translate3d(0,-85px,0);\n    transform: translate3d(0,-85px,0);\n}\n\n.titlebar-left {\n    overflow-x: auto;\n    overflow-y: hidden;\n    white-space: nowrap;\n}\n\n.titlebar-right {\n    float: right;\n}\n\n.activitytool {\n    display: inline-block;\n}\n\ndiv[class^='bbtools-'],\ndiv[class^='fctools-'] {\n    width: 80px;\n    height: 35px;\n    background-size: contain;\n    float: left;\n    margin: 5px 0;\n    border-right: 1px solid #c9c9c9;\n    cursor: pointer;\n    /* IE 8 */\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";\n    /* IE 5-7 */\n    filter: alpha(opacity=50);\n    /* Netscape */\n    -moz-opacity: 0.5;\n    /* Safari 1.x */\n    -khtml-opacity: 0.5;\n    /* Good browsers */\n    opacity: 0.5;\n    text-align: left;\n    padding-left: 20px;\n}\n\ndiv[class^='bbtools-']:not(.bbtools-penciloptions):active,\ndiv[class^='bbtools-']:not(.bbtools-penciloptions).active {\n    /* IE 8 */\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n    /* IE 5-7 */\n    filter: alpha(opacity=100);\n    /* Netscape */\n    -moz-opacity: 1;\n    /* Safari 1.x */\n    -khtml-opacity: 1;\n    /* Good browsers */\n    opacity: 1;\n}\n\n.titlebar-right div[class^='bbtools-']:last-child {\n    border-right: none;\n}\n\n.bbtools-lessonsettings,\n.bbtools-tutorialvideos {\n    font-size: 32px;\n    font-size: 3.2rem;\n}\n\n.bbtools-text {\n    font-size: 32px;\n    font-size: 3.2rem;\n}\n\n.bbtools-text i {\n    padding-left: 12px;\n}\n\n.bbtools-tiledrawer {\n    background: url('../img/bbtools-tiledrawer.png') no-repeat center center;\n}\n\n.bbtools-pencil {\n    background: url('../img/bbtools-pencil.png') no-repeat center center;\n    color: #000;\n    font-size: 12px;\n    font-size: 1.2rem;\n}\n\n.bbtools-eraser {\n    background: url('../img/bbtools-eraser.png') no-repeat center center;\n}\n\n.bbtools-undo {\n    background: url('../img/bbtools-undo.png') no-repeat center center;\n}\n\n.bbtools-shift {\n    background: url('../img/bbtools-shift.png') no-repeat center center;\n}\n\n.bbtools-hide {\n    background: url('../img/bbtools-hide.png') no-repeat center center;\n}\n\n.bbtools-resize {\n    background: url('../img/bbtools-resize.png') no-repeat center center;\n}\n\ndiv[class^='fctools-'].fctools-syllabledivision {\n    background: url('../img/fctools-syllabledivision.png') no-repeat top center;\n}\n\ndiv[class^='fctools-'].fctools-syllabledivision.active {\n    background-position: bottom center;\n}\n\n.bbtools-trash {\n    background: url('../img/bbtools-trash.png') no-repeat center center;\n}\n\ndiv[class='bbtools-penciloptions'] {\n    font-size: 30px;\n    letter-spacing: 0.5em;\n    width: auto;\n    padding: 2px 10px 0 20px;\n}\n\ndiv.text-tool-draw {\n    width:100%;\n    height:100%;\n}\n\ndiv.text-tool-draw.pullout {\n    padding-bottom: 30px;\n}\n\ndiv.text-tool-active {\n    cursor: text;\n}\n\ndiv.text-box {\n    background: rgba(255,255,255,.8);\n    border-radius: 10px;\n    padding: 12px 25px 12px 25px;\n    z-index: 5;\n    cursor: move;\n}\n\ndiv.text-box.ui-draggable-dragging {\n    border: 1px dotted black;\n}\n\ndiv.text-box .close-text {\n    position: absolute;\n    top: 10px;\n    right: 5px;\n    height: 40px;\n    font-size: 20px;\n    opacity: .4;\n    color: lightcoral;\n    cursor: default;\n}\n\ndiv.text-box textarea {\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    background: none;\n    resize: none;\n    -webkit-user-select: text;\n    border: 1px rgba(0,0,0,.1) dotted;\n    padding: 2px;\n    font-size: 26px;\n}\n\ndiv.text-box .text-size-plus {\n    font-size: 20px;\n    position: absolute;\n    top: 10px;\n    left: -7px;\n    width: 40px;\n    height: 40px;\n    line-height: 40px;\n    text-align: center;\n    -webkit-user-select: none;\n    cursor: default;\n}\n\ndiv.text-box .text-size-minus {\n    font-size: 20px;\n    position: absolute;\n    bottom: 0px;\n    left: -7px;\n    width: 40px;\n    height: 40px;\n    line-height: 40px;\n    text-align: center;\n    -webkit-user-select: none;\n    cursor: default;\n}\n\ndiv.text-box.hidden {\n    visibility: visible !important;\n    background: transparent;\n}\n\ndiv.text-box.hidden .close-text, div.text-box.hidden .text-size-plus, div.text-box.hidden .text-size-minus, div.text-box.hidden .ui-resizable-handle {\n    display: none !important;\n}\n\ndiv.text-box.hidden textarea {\n    border: 1px solid transparent;\n    visibility: visible;\n}\n\nspan.text-width-span {\n    margin:0;\n    padding: 3px;\n    display: table-cell;\n}\n\n.ui-selectable-helper {\n    background: rgba(255,255,255,.8);\n    border-radius: 10px;\n}\n\n.lessonbox_wrapper {\n    position: absolute;\n    top: 50px;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    padding: 50px;\n    z-index: 151;\n}\n\n.fa.black {\n    color: #000;\n}\n\n.fa.blue {\n    color: #004aff;\n}\n\n.fa.red {\n    color: #ab1f2c;\n}\n\n.fa.yellow {\n    color: #ffe400;\n}\n\n.fa.green {\n    color: #1eff00;\n}\n\n.fa.purple {\n    color: #fc00ff;\n}\n\n.fa.orange {\n    color: #ff8a00;\n}\n\n.fa.pink {\n    color: #ff00ae;\n}\n\n#page-container {\n    font-size: 15px;\n    font-size: 1.5rem;\n    height: 100%;\n    width: auto;\n    overflow:hidden;\n    transition: all .25s ease-out;\n}\n\ndiv[id^='page-'] {\n    transition: all .2s ease-out;\n}\n\ndiv[id^='page-'].ng-enter {\n    transition: all .1s ease-out;\n    -moz-opacity: 0;\n    opacity: 0;\n}\n\ndiv[id^='page-'].ng-enter-active {\n    -moz-opacity: 1;\n    opacity: 1;\n}\n\ndiv[id^='page-'].ng-leave {\n    -moz-opacity: 1;\n    opacity: 1;\n    -moz-transform: scale(1);\n    -webkit-transform: scale(1);\n    -o-transform: scale(1);\n    -ms-transform: scale(1);\n    transform: scale(1);\n}\n\ndiv[id^='page-'].ng-leave-active {\n    -moz-opacity: 0;\n    opacity: 0;\n    -moz-transform: scale(0.99);\n    -webkit-transform: scale(0.99);\n    -o-transform: scale(0.99);\n    -ms-transform: scale(0.99);\n    transform: scale(0.99);\n}\n\n@media DISABLED {\n    test {\n        /* IE 8 */\n        -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n        /* IE 5-7 */\n        filter: alpha(opacity=0);\n        /* Netscape */\n        -moz-opacity: 0;\n        /* Safari 1.x */\n        -khtml-opacity: 0;\n        /* Good browsers */\n        opacity: 0;\n    }\n\n    #page-container.here {\n        /* IE 8 */\n        -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n        /* IE 5-7 */\n        filter: alpha(opacity=100);\n        /* Netscape */\n        -moz-opacity: 1;\n        /* Safari 1.x */\n        -khtml-opacity: 1;\n        /* Good browsers */\n        opacity: 1;\n    }\n}\n\n\n.clear {\n    float: right;\n    padding: 10px 20px;\n    font-size: 15px;\n}\n\n.letter-tile {\n    font-family: \"Arial\", sans-serif;\n    font-size: 30px;\n    font-size: 3.0rem;\n    font-weight: bold;\n    color: #fff;\n    border-radius: 3px;\n    border: 1px solid #CCC;\n    display: inline-block;\n    float: left;\n    text-align: center;\n    line-height: 1.8em;\n    padding: 0 17px;\n    min-width: 73px;\n    cursor: pointer;\n    background: #fff;\n    margin: 3px 2px;\n    z-index: 15;\n    position:relative;\n    box-shadow: 0px 1px #BBB;\n    -ms-touch-action: none;\n}\n\n.letter-tile.capitalize {\n    text-transform: capitalize;\n}\n\n.letter-tile-added {\n    box-shadow: 0px 1px #BBB;\n}\n\n.letter-tile.ui-draggable-dragging {\n    z-index: 999999;\n}\n\n.open-tile-drawer {\n    float: right;\n    padding: 10px 20px;\n    font-size: 15px;\n}\n\n.page-header {\n    width: 100%;\n    overflow: auto;\n}\n\n.page-header h1 {\n    display: block;\n    float: left;\n}\n\n.page-header h3 {\n    display: block;\n    float: right;\n    margin: 0.5em 0;\n}\n\n#modal-loggout {\n    font-size: 14px;\n    font-size: 1.4rem;\n}\n\n.base {\n    display: -moz-inline-stack;\n    display: inline-block;\n    vertical-align: middle;\n    *vertical-align: auto;\n    zoom: 1;\n    *display: inline;\n    -webkit-border-radius: 3px;\n    -moz-border-radius: 3px;\n    -ms-border-radius: 3px;\n    -o-border-radius: 3px;\n    border-radius: 3px;\n    cursor: pointer;\n    border: 0;\n    margin: 0 0.5em 0.5em 0;\n    font-family: Arial;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n    font-size: 0.8em;\n    line-height: 1em;\n    padding: 1em 2.5em;\n    background: #FF8F2C;\n    color: #FFF;\n    outline: none;\n    box-shadow: 0 1px 1px #646464;\n    text-decoration: none;\n    outline: none;\n}\n\n\nbutton.secondary {\n    background: #eeeeee;\n    color: #888888;\n}\n\nbutton.darkgray {\n    background: #AAA;\n    color: #FFF;\n}\n\nbutton.icon {\n    display: inline-block;\n    text-align: center;\n    padding: 0.8em;\n    box-shadow: none;\n    border: 1px solid #D8D8D8;\n    width: 70px;\n}\n\nbutton.icon i {\n    font-size: 27px;\n    font-size: 2.7rem;\n    text-align: center;\n    display: block;\n    margin-bottom: 0.15em;\n}\n\nbutton.icon span {\n    font-size: 1.0px;\n    font-size: 1.0rem;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n    text-align: center;\n    display:block;\n}\n\nbutton.icon.highlight {\n    border:1px solid #EDA465;\n}\n\nbutton[disabled] {\n    opacity: 0.5;\n}\n\na.button {\n    display: -moz-inline-stack;\n    display: inline-block;\n    vertical-align: middle;\n    *vertical-align: auto;\n    zoom: 1;\n    *display: inline;\n    -webkit-border-radius: 3px;\n    -moz-border-radius: 3px;\n    -ms-border-radius: 3px;\n    -o-border-radius: 3px;\n    border-radius: 3px;\n    cursor: pointer;\n    border: 0;\n    margin: 0 0.5em 0 0;\n    font-family: inherit;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n    font-size: 0.8em;\n    line-height: 1em;\n    padding: 1em 2.5em;\n    background: #FF8F2C;\n    color: white;\n    outline: none;\n    font-weight: bold;\n    box-shadow: 0 1px 1px #646464;\n}\n\na.button.secondary {\n    background: #E9E9E9;\n    color: #888888;\n}\n\nbutton:active,\na.button:active {\n    box-shadow: inset 0px 1px 4px #4D4D4D;\n    margin-top: 1px;\n}\n\na.ngclicklink {\n    font-weight: bold;\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.supportVideoLink {\n    color: #CACACA;\n}\n\n.black-bg,\n.black-bg-modal {\n    position: absolute;\n    width: 100%;\n    transition: opacity 0.2s; /* ease-out, top 0 0.2s, bottom 0 0.2s; /* Fade out over 0.2s, then translate away at 0.2s,  */\n    background: #000;\n    background: rgba(0,0,0,.8);\n    /* IE 8 */\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    /* IE 5-7 */\n    filter: alpha(opacity=0);\n    /* Netscape */\n    -moz-opacity: 0;\n    /* Safari 1.x */\n    -khtml-opacity: 0;\n    /* Good browsers */\n    opacity: 0;\n    top: -9999px;\n    bottom: 9999px;\n    left: 0;\n    z-index: 150;\n}\n\n.black-bg-modal.active {\n    top: 0px;\n    bottom: 0px;\n    transition: opacity 0.2s; /* ease-out, top 0, bottom 0; /* Translate into place over 0.2s, fade in at 0.2s */\n    /* IE 8 */\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n    /* IE 5-7 */\n    filter: alpha(opacity=100);\n    /* Netscape */\n    -moz-opacity: 1.0;\n    /* Safari 1.x */\n    -khtml-opacity: 1.0;\n    /* Good browsers */\n    opacity: 1.0;\n}\n\n.black-bg.active {\n    top: 50px;\n    bottom: 0px;\n    transition: opacity 0.2s ease-out, top 0, bottom 0; /* Translate into place over 0.2s, fade in at 0.2s */\n    /* IE 8 */\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n    /* IE 5-7 */\n    filter: alpha(opacity=100);\n    /* Netscape */\n    -moz-opacity: 1.0;\n    /* Safari 1.x */\n    -khtml-opacity: 1.0;\n    /* Good browsers */\n    opacity: 1.0;\n}\n\n.black-bg.active.full {\n    top: 0px;\n}\n\n.slidemenu {\n    padding-bottom: 100px;\n}\n\n.slidemenu.menuright {\n    z-index: 151;\n    position: absolute;\n    right: 0;\n    top: 51px;\n    bottom: 0px;\n    width: 200px;\n    background: #e6e6e6;\n    box-shadow: inset 2px 0px 5px #A0A0A0;\n    transition: all .2s ease-out;\n    -webkit-transform: translate3d(200px,0,0);\n    -moz-transform: translate3d(200px,0,0);\n    -ms-transform: translate3d(200px,0,0);\n    -o-transform: translate3d(200px,0,0);\n    transform: translate3d(200px,0,0);\n    overflow-x: hidden;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n}\n\n.slidemenu.menuright.active {\n     -webkit-transform: translate3d(0,0,0);\n    -moz-transform: translate3d(0,0,0);\n    -ms-transform: translate3d(0,0,0);\n    -o-transform: translate3d(0,0,0);\n    transform: translate3d(0,0,0);\n}\n\n.slidemenu.menuleft {\n    z-index: 151;\n    position: absolute;\n    left: 0;\n    top: 51px;\n    bottom: 0px;\n    width: 300px;\n    background: #e6e6e6;\n    box-shadow: inset 2px 0px 5px #A0A0A0;\n    transition: all .2s ease-out;\n    -webkit-transform: translate3d(-300px,0,0);\n    -moz-transform: translate3d(-300px,0,0);\n    -ms-transform: translate3d(-300px,0,0);\n    -o-transform: translate3d(-300px,0,0);\n    transform: translate3d(-300px,0,0);\n    overflow-x: hidden;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n}\n\n.slidemenu.menuleft.active {\n     -webkit-transform: translate3d(0,0,0);\n    -moz-transform: translate3d(0,0,0);\n    -ms-transform: translate3d(0,0,0);\n    -o-transform: translate3d(0,0,0);\n    transform: translate3d(0,0,0);\n}\n\n.slidemenu ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.slidemenu ul li {\n    font-size: 16px;\n    font-size: 1.6rem;\n    font-family: 'Arial';\n    font-weight: bold;\n    padding: 16px;\n    border-bottom: 1px solid #cacaca;\n}\n\n.slidemenu ul li.disabled {\n    opacity: .5;\n}\n\n.slidemenu ul li:hover {\n    background: #CDCDCD;\n    cursor: pointer;\n}\n\n.slidemenu ul li:active {\n    background: #CDCDCD;\n    cursor: pointer;\n}\n\n.slidemenu.menuleft ul li {\n    font-size: 13px;\n    font-size: 1.3rem;\n    font-weight: normal;\n    padding: 15px;\n}\n\n.scroll-fix-wrapper {\n    overflow: auto;\n    -webkit-transform: translateZ(0);\n    height: 100%;\n}\n\n.scrollable {\n    -webkit-overflow-scrolling: touch;\n}\n\n/*= ALERT BOXES\n============================================================*/\n\n.alert-box {\n    color:#555;\n    border-radius:6px;\n    font-family:Arial,sans-serif;\n    font-size: 12px;\n    font-size: 1.2rem;\n    padding: 10px 20px;\n    line-height: 1.4em;\n    margin:0 0 20px;\n}\n\n.alert-box span {\n    font-weight:bold;\n    text-transform:uppercase;\n}\n\n.error {\n    background:#ffecec;\n    border:1px solid #f5aca6;\n}\n.success {\n    background:#e9ffd9;\n    border:1px solid #a6ca8a;\n}\n.warning {\n    background:#fff8c4;\n    border:1px solid #f2c779;\n}\n.notice {\n    background:#e3f7fc;\n    border:1px solid #8ed9f6;\n}\n\n/*= LAYOUT FRAMES\n=================================================*/\n\n.paperbox {\n    border-radius: 3px;\n    border: 1px solid #DDD;\n    box-shadow: 0px 1px 1px #AAA;\n    background: rgba(248, 248, 248, 1);\n}\n\n.paperbox.new {\n    background: rgba(250, 250, 250, 0.5);\n    padding: 15px;\n    box-shadow: none;\n    border: 1.5px dashed #BBB;\n    cursor: pointer;\n}\n\n.paperbox.new :active {\n    background: rgba(250, 250, 250, 1);\n}\n\n.paperbox.warning {\n    background: rgba(250, 250, 207, 0.5);\n    padding: 15px;\n    box-shadow: none;\n    border: 1.5px dashed #DBD37A;\n    cursor: pointer;\n}\n\n.paperbox.inverse {\n    box-shadow: inset 0px 1px 1px #AAA;\n    border: 1px solid #D2D2D2;\n}\n\n.paperbox .closebutton {\n    float: right;\n    font-size: 20px;\n    font-size: 2.0rem;\n    cursor: pointer;\n}\n\n.paperbox .title {\n    font-size: 13px;\n    font-size: 1.3rem;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n    font-weight: bold;\n    padding-bottom: 0.8em;\n    display: block;\n    border-bottom: 1px solid #CCC;\n    margin-bottom: 15px;\n}\n\n.paperbox .title .title_action {\n    text-transform: none;\n    letter-spacing: 0;\n    float: right;\n    font-size: 14px;\n    font-weight: normal;\n}\n\n.inputblock {\n    display: inline-block;\n    margin-right: 20px;\n    margin-bottom: 15px;\n}\n\n/*= AUDIO PLAY BUTTON\n=================================================*/\n\nbutton.audio-button,\n.audio-button {\n    display: inline-block;\n    border-radius: 50%;\n    width: 50px;\n    height: 50px;\n    line-height: 50px;\n    padding: 0;\n    text-align: center;\n    font-size: 20px;\n    text-indent: 4px;\n}\n\n.audio-button {\n    margin-right: 15px;\n}\n\n/*= MODAL STYLES\n=================================================*/\n\n.modal {\n    position: fixed;\n    z-index: 151;\n    width: 400px;\n    margin-left: -200px;\n    left: 50%;\n    top: -2000px;\n    -webkit-border-radius: 5px;\n    -moz-border-radius: 5px;\n    -ms-border-radius: 5px;\n    -o-border-radius: 5px;\n    border-radius: 5px;\n    font-family: inherit;\n    background: white;\n    color: #444444;\n    font-size: 16px;\n    font-size: 1.6rem;\n    line-height: 1.5em;\n    -webkit-transform: translateZ(0);\n    -moz-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    -o-transform: translateZ(0);\n    transform: translateZ(0);\n    transition: all 0.4s;\n    -webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));\n    -moz-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));\n    filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));\n}\n\n.modal.video {\n    width: 690px;\n    margin-left: -345px;\n}\n\n.modal.modal_tour {\n    width: 600px;\n    margin-left: -300px;\n}\n\n.modal.active {\n    top: 18%;\n     -webkit-transform: translate3d(0,0,0);\n    -moz-transform: translate3d(0,0,0);\n    -ms-transform: translate3d(0,0,0);\n    -o-transform: translate3d(0,0,0);\n    transform: translate3d(0,0,0);\n}\n\n.modal header {\n    background: #eeeeee;\n    padding: 1em;\n    -webkit-border-radius: 5px 5px 0 0;\n    -moz-border-radius: 5px 5px 0 0;\n    -ms-border-radius: 5px 5px 0 0;\n    -o-border-radius: 5px 5px 0 0;\n    border-radius: 5px 5px 0 0;\n    overflow: auto;\n    padding: 1em;\n}\n\n.modal header h3 {\n     float: left;\n     line-height: 1em;\n     margin: 0;\n     font-weight: normal;\n}\n\n.modal header a.modal-cancel-link {\n    float: right;\n    text-decoration: none;\n    font-size: 1.25em;\n    line-height: 0.8em;\n    font-weight: normal;\n    color: rgba(0, 0, 0, 0.5);\n    opacity: 0.25;\n    position: relative;\n    margin-bottom: -0.8em;\n}\n\n.modal header a.modal-cancel-link:hover {\n    opacity: 1;\n}\n\n.modal .modal-spinner {\n    padding: 30px 0;\n    text-align: center;\n}\n\n.modal .modal-body {\n    padding: 1.5em;\n    overflow: auto;\n}\n\n.modal .modal-body.restrict-height {\n    max-height: 420px;\n}\n\n.modal .modal-body.no-padding {\n    padding: 0;\n}\n\n.modal .modal-body p {\n    margin-top: 0;\n    padding-top: 0;\n    margin-bottom: 30px;\n}\n\n.modal_tour_carousel {\n    min-height: 460px;\n    margin: 0;\n    padding: 0;\n}\n\n.modal-body .modal_tour_carousel p {\n    padding: 10px 20px;\n    margin: 0;\n}\n\n.fa.bigsign {\n    font-size: 180px;\n    font-size: 18.0rem;\n    opacity: 0.5;\n}\n\n.fa.mediumsign {\n    font-size: 100px;\n    font-size: 10.0rem;\n    opacity: 0.5;\n    margin-bottom: 15px;\n}\n\n.modal form label {\n    display: inline-block;\n    margin-bottom: 10px;\n    color: #5E5E5E;\n    width: 100%;\n}\n\n.modal form label.half-width {\n    width: 49%;\n}\n\n.modal form label.half-width input {\n    width: 90%;\n}\n\n.modal form input[type=\"text\"],\n.modal form input[type=\"number\"],\n.modal form input[type=\"email\"],\n.modal form textarea {\n    color: #555;\n    width: 100%;\n    padding: 0px 8px;\n    margin-top: 2px;\n    margin-bottom: 10px;\n    border: 1px solid #DDD;\n    background: #FBFBFB;\n    outline: 0;\n    -webkit-box-shadow: inset 1px 1px 2px rgba(238, 238, 238, 0.2);\n    box-shadow: inset 1px 1px 2px rgba(238, 238, 238, 0.2);\n}\n\n.modal form select {\n    -webkit-appearance: none;\n    border: 1px solid #DDD;\n    padding: 10px;\n    font-size: 15px;\n    border-radius: 3px;\n    color: #707070;\n    line-height: 1.2em;\n    width: 180px;\n    background: #fff url('../img/dropdown-bg.png') no-repeat center right;\n    background-size: contain;\n    margin: 5px 0;\n    width: 100%;\n}\n\n.modal form textarea {\n    height: 200px;\n    padding: 10px;\n}\n\n.modal ul.menu-list {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n}\n\n.modal ul.menu-list li {\n    cursor: pointer;\n    margin: 0;\n    padding: 20px;\n    border-bottom: 1px solid #CCC;\n}\n\n.modal ul.menu-list li:hover {\n    background: #f8f8f8;\n}\n\n.modal .footer {\n    margin-top: 8px;\n    text-align: center;\n}\n\n/*= ANIMATING LOADER STYLES\n=================================================*/\n\n.spinner {\n  margin: 0 auto;\n  width: 50px;\n  text-align: center;\n}\n\n.page-loader {\n    height: 100%;\n    width: auto;\n    overflow: hidden;\n}\n\n.spinner > div {\n  width: 10px;\n  height: 10px;\n  background-color: #9CA3B4;\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: bouncedelay 1.4s infinite ease-in-out;\n  animation: bouncedelay 1.4s infinite ease-in-out;\n  /* Prevent first frame from flickering when animation starts */\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n.page-loader .spinner {\n    position: absolute;\n    top: 40%;\n    width: 100%;\n}\n\n.page-loader .spinner.page-error {\n    top: 35%;\n}\n\n.page-loader .spinner.page-error > i {\n    font-size: 80px;\n    font-size: 8.0rem;\n}\n\n.page-loader .page-loader-quotes {\n    position: absolute;\n    text-align: center;\n    top: 45%;\n    width: 100%;\n    margin-top: 20px;\n    font-size: 1.8rem;\n    line-height: 1.5em;\n}\n\n.page-loader .spinner > div {\n    width: 20px;\n    height: 20px;\n}\n\n.spinner .bounce1 {\n  -webkit-animation-delay: -0.32s;\n  animation-delay: -0.32s;\n}\n\n.spinner .bounce2 {\n  -webkit-animation-delay: -0.16s;\n  animation-delay: -0.16s;\n}\n\n@-webkit-keyframes bouncedelay {\n  0%, 80%, 100% { -webkit-transform: scale(0.0) }\n  40% { -webkit-transform: scale(1.0) }\n}\n\n@keyframes bouncedelay {\n  0%, 80%, 100% {\n    transform: scale(0.0);\n    -webkit-transform: scale(0.0);\n  } 40% {\n    transform: scale(1.0);\n    -webkit-transform: scale(1.0);\n  }\n}\n\n/*= Activity Tool Styles\n=================================================*/\n\n.red-circle {\n    width: 8px;\n    height: 8px;\n    background: #ff5a5a;\n    border-radius: 50px;\n    position: absolute;\n    right: 4px;\n    top: 4px;\n}\n\n.disable-activity {\n    cursor: not-allowed !important;\n    color: lightgrey !important;\n}\n\n#sketch-blocker {\n    position: absolute;\n    top: 0px;\n    z-index: 11;\n    width: 100%;\n    height: 100%;\n    display: none;\n    -ms-touch-action: none;\n}\n\n.hide-arrow{\n    display: none;\n}\n\n#pulloutscreen {\n    z-index: 18;\n    width: 96%;\n    height: 2000px;\n    position: absolute;\n    top: -1868px;\n    left: 50%;\n    margin-left: -48%;\n    background: #fff;\n    /*border: 1px solid #c7ca81;*/\n    -webkit-box-shadow: 0px 2px 5px rgba(0,0,0,0.132);\n    -moz-box-shadow: 0px 2px 5px rgba(0,0,0,0.132);\n    box-shadow: 0px 2px 5px rgba(0,0,0,0.132);\n    background: rgb(255,255,255,0.22); /* Old browsers */\n    background: -moz-linear-gradient(top, rgba(255,255,255,0.22) 0%, rgba(255,252,246,0.22) 100%); /* FF3.6+ */\n    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(255,255,255,0.22)), color-stop(100%,rgba(255,252,246,0.22))); /* Chrome,Safari4+ */\n    background: -webkit-linear-gradient(top, rgba(255,255,255,0.22) 0%,rgba(255,252,246,0.22) 100%); /* Chrome10+,Safari5.1+ */\n    background: -o-linear-gradient(top, rgba(255,255,255,0.22) 0%,rgba(255,252,246,0.22) 100%); /* Opera 11.10+ */\n    background: -ms-linear-gradient(top, rgba(255,255,255,0.22) 0%,rgba(255,252,246,0.22) 100%); /* IE10+ */\n    background: linear-gradient(to bottom, rgba(255,255,255,0.22) 0%,rgba(255,252,246,0.22) 100%); /* W3C */\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#fffcf6',GradientType=0 ); /* IE6-9 */\n    transition: all .18s ease-out;\n    -webkit-transform: translate3d(0,0,0);\n    -moz-transform: translate3d(0,0,0);\n    -ms-transform: translate3d(0,0,0);\n    -o-transform: translate3d(0,0,0);\n    transform: translate3d(0,0,0);\n}\n\n#pulloutscreen-sketch {\n    height: 2000px;\n    width: 100%;\n}\n\n#pulloutscreen-handle {\n    width: 100%;\n    height: 30px;\n    position: absolute;\n    bottom: -3px;\n    background: url('../img/transparencyhandle.png') no-repeat center bottom;\n}\n\n.no_content_container{\n    padding: 50px 200px 0 200px;\n    height: 100%;\n    font-size: 2.5rem;\n    font-weight: bold;\n    text-align: center;\n}\n.videowrapper_no_content{\n    width: 400px;\n    height: 225px;\n    position: relative;\n    right: 0;\n    left: 0;\n    margin: auto;\n    margin-bottom: 20px;\n}\n\n.add_content_btn{\n    width: 170px;\n    margin-top: 30px !important;\n    font-size: small;\n    padding-right: 0;\n    padding-left: 0;\n}\n\n.no_content_message{\n    font-size: 20px;\n}\n\n.workbook_arrow{\n     cursor: pointer;\n     font-size: larger !important;\n     margin-left: 10px;\n     margin-right: 10px;\n }\n\n.header_cover {\n    height: 50px;\n    z-index: 21;\n    width: 100%;\n    background-color: gray;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    right: 0px;\n    -moz-opacity: 0.4;;\n    -khtml-opacity: 0.4;;\n    opacity: 0.4;\n}\n\n.word-bar {\n  width: 15%;\n  background-color: #F8F8F8;\n}\n\n.word {\n  padding: 20px;\n  border-bottom: 2px #ccc solid;\n}\n\n.word span {\n  font-size: larger;\n}\n\n.workbook-edit-name {\n  font-size: x-large;\n  width: 50%;\n  color: #888;\n  margin-left: 20px;\n  margin-top: 15px;\n}\n\napp-header-element {\n  z-index: 100;\n}\n\n\n/* .flashcard {\n  font-family: \"Arial\", sans-serif;\n  font-size: 120px !important;\n  line-height: 15vw;\n  font-weight: bold;\n  display: inline-block;\n  width: auto !important;\n  height: 433px !important;\n  text-align: center;\n  padding-top: 3%;\n  flex-shrink: 3;\n  border-radius: 8px ;\n  box-shadow: 0 4px 16px 0 rgba(33, 8, 84, 0.08) ;\n  background-color: #ffffff;\n  color: #210854 ;\n} */\n\n.tiles {\n  height: 20vh;\n  line-height: 6rem;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n\n.bumping-tile {\n  border: 2px black solid;\n  height: 100px;\n  width: 100px;\n  position: absolute;\n  text-align: center;\n}\n\n\n/* header styling */\n.sidenav {\n    width: 20vh;\n    height: 100vw;\n    position: fixed;\n    background-color: black;\n    z-index: 100;\n    float: left;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
